import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import Loader from "react-loader-spinner";
import GetDomains from "../GetDomains";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";

class ScheduleReport extends Component {
  constructor() {
    super();
    this.multiselectRef = React.createRef();
    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false,
        hideAddDialog: false,
        hideDeletePopup: false,
        selectedDailyReportDomains: [],
      });
    };

    this.settings = {
      effect: "Zoom",
      duration: 400,
      delay: 0,
      position: "center",
    };

    this.addedButton = [
      {
        buttonModel: {
          content: "OK",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.fetchDataApi();
          this.dialogClose();
          this.setState({});
        },
      },
    ];

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteScheduleReportAPi(this.state.fields.id);

          this.state.hideDeleteSuccessPopup = true;
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchDataApi();
          this.setState({ disabled: false });
        },
      },
    ];

    this.state = {
      selectedReportType: "",
      showTrustedEmailId: false,
      items: [],
      trustedItems: [],
      value: [],
      trustedValue: [],
      error: null,
      trustedError: null,
      editedId: 0,
      fields: {},
      types: [],
      timeZone: null,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      Username: "",
      Useremail: "",
      count: "",
      successResp: false,
      selectedDomainName: null,
      selectedDomainId: null,
    };
    this.domains = [];
    this.emailIdInList = [];
    this.trustedemailIdInList = [];
    this.afterDeleting = [];
    this.trustedEmailafterDeleting = [];
    this.allEmail = [];
  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchDomainsApi();
      this.fetchScheduleReportTypeApi();
      this.fetchTimeZoneApi();
      this.fetchDataApi();
    }, 0);

    document.getElementById("timeZone").value =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    var thisController = this;

    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.domains = [];
      thisController.fetchDomainsApi();
      thisController.fetchScheduleReportTypeApi(event.projectId);
      thisController.fetchTimeZoneApi();
      thisController.fetchDataApi(event.projectId);
    });
  }

  handleDailyReportDomainChange = (selectedDailyReportDomains) => {
    this.setState({ selectedDailyReportDomains: this.cleanDomainLabels(selectedDailyReportDomains) });
  };

  cleanDomainLabels = (domainsList = []) => {
    // return domainsList.map(domain => ({ ...domain, label: domain.label.trim().replace("↪", "") }));
    domainsList.forEach(domain => {
      domain.label = domain.label.trim().replace("↪", "");
    });
    return domainsList;
  
  }

  handleRemoveDailyReportDomain = (selectedDailyReportDomains) => {
    this.setState({ selectedDailyReportDomains: this.cleanDomainLabels(selectedDailyReportDomains) });
  };

  fetchDomainsApi = () => {
    var domainList = GetDomains();
    var isDomainIdInCurrentProject = false;
    for (var i = 0; i < domainList.length; i++) {
      if (
        localStorage.getItem("convDataDomainId") !== undefined &&
        domainList[i]["domainId"] === localStorage.getItem("convDataDomainId")
      ) {
        isDomainIdInCurrentProject = true;
      }
      this.domains.push({
        value: domainList[i]["domainId"],
        label: domainList[i]["domain"],
      });
    }

    if (this.props.location.state !== undefined) {
      if (isDomainIdInCurrentProject) {
        this.state.selectedDomainName =
          localStorage.getItem("convDataDomainName");
        this.state.selectedDomainId = localStorage.getItem("convDataDomainId");
      } else {
        this.state.selectedDomainName = this.domains[0].label;
        this.state.selectedDomainId = domainList[0]["domainId"];
      }
    } else {
      this.state.selectedDomainName = this.domains[0].label;
      this.state.selectedDomainId = domainList[0]["domainId"];
    }
  };

  handleDomainChange = (e) => {
    console.log("Changed to domain: " + e.label);
    this.state.selectedDomainName = e.label;
    this.state.selectedDomainId = e.value;
    localStorage.setItem("convDataDomainName", e.label);
    localStorage.setItem("convDataDomainId", e.value);
    this.setState(this.state);
  };

  editContent = (event) => {
    this.setState({ editedId: "-1" });
  };

  showPopup = () => {
    this.setState({
      hideDeletePopup: true,
    });
  };

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  };
  timeZonehandleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  };

  emailIdValidation = (e) => {
    let fields = this.state.data;
    fields[e.target.name] = e.target.value;
    var commaSeperated = fields[e.target.name];
    var splitedValue = commaSeperated.split(",");
    this.setState({
      name: splitedValue[0],
      email: splitedValue[1],
    });
  };

  validateFields(time, emailId, timeZone, trustedMailId) {
    if (trustedMailId == "" && emailId == "") {
      this.notifyInvalidEmail();
      return false;
    } else if (
      time == null ||
      time == "" ||
      timeZone == null ||
      timeZone == ""
    ) {
      this.notifyMsgFieldEmpty();
      return false;
    } else {
      return true;
    }
  }
  notifyInvalidEmail() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill the email according to the given formate
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the data
      </b>,
      {
        position: "top-center",
      }
    );
  }

  validateNewDataFields() {
    let fields = this.state.data;
    if (!fields["newtime"] && !fields["newemailId"] && !fields["newtimeZone"]) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    return true;
  }

  handleReportType = (e) => {
    this.state.selectedReportType = e.target.value;
    this.state.editedId = "-1";
    this.fetchDataApi();
  };
  handleTimeZone = (e) => {
    this.state.editedId = "-1";
    this.fetchScheduleReportTypeApi();
  };

  saveScheduleReportApi = (props) => {
    props.preventDefault();
    let saveScheduleReportController = this;
    this.state.editedId = "0";
    this.setState(this.state);
    var validatedData = this.validateFields(
      document.getElementById("time").value,
      saveScheduleReportController.emailIdInList,
      document.getElementById("timeZone").value,
      saveScheduleReportController.trustedemailIdInList
    );
    var timeSplit = document.getElementById("time").value.split(":"),
      hours,
      minutes,
      meridian;
    hours = timeSplit[0];
    minutes = timeSplit[1];
    if (hours > 12) {
      meridian = "PM";
      hours -= 12;
    } else if (hours < 12) {
      meridian = "AM";
      if (hours == 0) {
        hours = 12;
      }
    } else {
      meridian = "PM";
    }
    var timeFormate = hours + ":" + minutes + " " + meridian;
    let domainSelected = true;

    if (validatedData == true) {
      for (
        var i = 0;
        i < saveScheduleReportController.trustedemailIdInList.length;
        i++
      ) {
        saveScheduleReportController.emailIdInList.push(
          saveScheduleReportController.trustedemailIdInList[i]
        );
      }
      var data = {
        projectId: localStorage.getItem("currentProjectId"),
        scheduleReportType:
          saveScheduleReportController.state.selectedReportType,
        time: timeFormate,
        emailId: saveScheduleReportController.emailIdInList,
        timeZone: document.getElementById("timeZone").value,
      };

      if (data.scheduleReportType === 'DOMAIN_WISE_REPORT') {
        if (saveScheduleReportController.state.selectedDomainId != null) {
          data.parentDomainIds = [saveScheduleReportController.state.selectedDomainId];
        } else {
          domainSelected = false;
        }
      }
      if (data.scheduleReportType === 'DAILY_SUMMARY') {
        if (saveScheduleReportController.state.selectedDailyReportDomains.length > 0) {
          data.parentDomainIds = saveScheduleReportController.state.selectedDailyReportDomains.map(domain => domain.value);
        } else {
          domainSelected = false;
        }
      }
    }
    if (domainSelected) {
      $.ajax({
        url: "/api/schedule-reports",
        async: false,
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),

        success: function (res) {
          if (res.success === true) {
            saveScheduleReportController.notifyAdd();
            saveScheduleReportController.fetchDataApi();
          } else {
            saveScheduleReportController.notifyError(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    } else {
      saveScheduleReportController.notifyError("Please select a domain");
    }

  };

  notifyAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Report Added Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyError(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        {response}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchScheduleReportTypeApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var scheduleTypeController = this;

    $.ajax({
      url: "/api/schedule-reports/types",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          scheduleTypeController.state.types = res.result;
          scheduleTypeController.state.selectedReportType =
            scheduleTypeController.state.types[0].code;
          scheduleTypeController.setState(scheduleTypeController.state);
        } else {
          scheduleTypeController.notifyError(res.result);
        }
      },
    });
  };

  fetchTimeZoneApi = () => {
    var timeZoneController = this;
    $.ajax({
      url: "/api/time-zones",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var loadTimeZone = res.result;
          timeZoneController.setState({ timeZone: loadTimeZone });
          var numberOfTimeZone = loadTimeZone.length;
          var ele3 = document.getElementById("timeZone");
          if (ele3 != null) {
            ele3.innerHTML = "";
            for (var i = 0; i < numberOfTimeZone; i++) {
              ele3.innerHTML =
                ele3.innerHTML +
                '<option value="' +
                loadTimeZone[i]["timeZoneName"] +
                '">' +
                loadTimeZone[i]["timeZoneName"] +
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                loadTimeZone[i]["timeZoneId"] +
                "</option>";
            }
          }
        } else {
          timeZoneController.notifyError(res.result);
        }
      },
    });
  };

  fetchDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var fetchReportDataController = this;
    $.ajax({
      url: "/api/schedule-reports",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
        type: fetchReportDataController.state.selectedReportType,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          fetchReportDataController.setState({
            successResp: true,
          });
          if (
            fetchReportDataController.state.selectedReportType == "DEVICE_DEMOGRAPHY" ||
            fetchReportDataController.state.selectedReportType == "LOCATION" ||
            fetchReportDataController.state.selectedReportType == "DAILY_SUMMARY"
          ) {
            fetchReportDataController.state.showTrustedEmailId = true;
          } else {
            fetchReportDataController.state.showTrustedEmailId = false;
          }
          var messages = res.result;
          if (document.getElementById("time") != null) {
            if (messages.id === null) {
              document.getElementById("time").value = "";
              document.getElementById("emailId").value = "";
              document.getElementById("timeZone").value =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              fetchReportDataController.setState({
                fields: {},
                value: "",
                editedId: "0",
                items: [],
                trustedItems: [],
              });
              (fetchReportDataController.emailIdInList = []),
                (fetchReportDataController.trustedemailIdInList = []);
            } else {
              var emailFormate = [];
              var buttonContent = [];
              var emailData = [];
              var trustedEmailData = [];
              var trustedbuttonContent = [];

              if (fetchReportDataController.state.selectedReportType === 'DOMAIN_WISE_REPORT') {
                for (let j = 0; j < messages.parentDomainIds.length; j++) {
                  let domainId = messages.parentDomainIds[0];
                  fetchReportDataController.state.selectedDomainId = domainId;
                  for (let v = 0; v < fetchReportDataController.domains.length; v++) {
                    if (fetchReportDataController.domains[v].value === domainId) {
                      fetchReportDataController.state.selectedDomainName = fetchReportDataController.domains[v].label;
                    }
                  }
                }
              }

              if (fetchReportDataController.state.selectedReportType === 'DAILY_SUMMARY') {
                fetchReportDataController.state.selectedDailyReportDomains = [];
                for (let j = 0; j < messages.parentDomainIds.length; j++) {
                  let domainId = messages.parentDomainIds[j];
                  for (let v = 0; v < fetchReportDataController.domains.length; v++) {
                    if (fetchReportDataController.domains[v].value === domainId) {
                      fetchReportDataController.state.selectedDailyReportDomains
                        .push(fetchReportDataController.domains[v]);
                    }
                  }
                }
              }

              for (var i = 0; i < messages.emailId.length; i++) {
                emailFormate[i] =
                  messages.emailId[i]["name"] +
                  "-" +
                  messages.emailId[i]["email"];

                if (messages.emailId[i]["trustedEmail"] == true) {
                  if (messages.scheduleReportType == "DAILY_SUMMARY") {
                    buttonContent.push(
                      messages.emailId[i]["name"] +
                      "," +
                      messages.emailId[i]["email"]
                    );
                  }
                  trustedbuttonContent.push(
                    messages.emailId[i]["name"] +
                    "," +
                    messages.emailId[i]["email"]
                  );
                  trustedEmailData.push({
                    name: messages.emailId[i]["name"],
                    email: messages.emailId[i]["email"],
                    trustedEmail: messages.emailId[i]["trustedEmail"],
                  });
                } else {
                  buttonContent.push(
                    messages.emailId[i]["name"] +
                    "," +
                    messages.emailId[i]["email"]
                  );
                  emailData.push({
                    name: messages.emailId[i]["name"],
                    email: messages.emailId[i]["email"],
                    trustedEmail: messages.emailId[i]["trustedEmail"],
                  });
                }
              }

              var ref = [];
              ref = messages["time"].split(" ");
              messages["time"] = ref[0];
              var hour = [];
              var hourModification = "";
              hour = messages["time"].split(":");
              if (ref[1] == "PM") {
                if (hour[0] != "12") {
                  hourModification = parseInt(hour[0]) + parseInt("12");
                  messages["time"] = hourModification + ":" + hour[1];
                }
              } else {
                if (hour[0] == "12") {
                  messages["time"] = "00" + ":" + hour[1];
                } else {
                  messages["time"] = ref[0];
                }
              }
              var timeZone = document.getElementById("timeZone").value;
              fetchReportDataController.setState({
                fields: messages,
                timeZone: messages["timeZone"],
                items: buttonContent,
                trustedItems: trustedbuttonContent,
                editedId: "0",
              });
              fetchReportDataController.emailIdInList = emailData;
              fetchReportDataController.trustedemailIdInList = trustedEmailData;
            }
          }
        } else {
          fetchReportDataController.notifyError(res.result);
        }
      },
    });
  };

  deleteScheduleReportAPi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    $.ajax({
      url: "/api/schedule-reports/" + id,
      async: false,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteApiViewController.notifyDelete();
          deleteApiViewController.fetchDataApi();
        } else {
          deleteApiViewController.notifyError(res.result);
        }
      },
    });
  };

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Report Deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleKeyDown = (evt) => {
    var scheduleReportComp = this;
    if (["Enter", "Tab"].includes(evt.key)) {
      evt.preventDefault();

      var value = [];
      value = scheduleReportComp.state.value;

      if (value && scheduleReportComp.isValid(value)) {
        scheduleReportComp.setState({
          items: [
            ...scheduleReportComp.state.items,
            scheduleReportComp.state.value,
          ],
          value: "",
        });
      }
    }
  };

  emailIdhandleChange = (evt) => {
    this.setState({
      value: evt.target.value,
      error: null,
    });
  };

  trustedEmailIdhandleChange = (evt) => {
    this.setState({
      trustedValue: evt.target.value,
      trustedError: null,
    });
  };

  handleDelete = (item) => {
    this.setState({
      items: this.state.items.filter((i) => i !== item),
    });

    this.afterDeleting = this.state.items.filter((i) => i !== item);
    this.emailIdInList = [];
    for (var i = 0; i < this.afterDeleting.length; i++) {
      var fetchedValue = this.afterDeleting[i];
      var commaSeperated = fetchedValue.split(",");
      var Username = commaSeperated[0];
      var Useremail = commaSeperated[1];

      var emailFieldController = this;

      if (Useremail && Username != null) {
        var trustedEmail = false;
        if (this.state.selectedReportType == "DAILY_SUMMARY") {
          trustedEmail = true;
        }
        this.emailIdInList.push({
          name: Username,
          email: Useremail,
          trustedEmail: trustedEmail,
        });
      }
    }
  };

  trustedEmailIdhandleChange = (evt) => {
    this.setState({
      trustedValue: evt.target.value,
      trustedError: null,
    });
  };

  trustedhandleDelete = (item) => {
    this.setState({
      trustedItems: this.state.trustedItems.filter((i) => i !== item),
    });

    this.trustedEmailafterDeleting = this.state.trustedItems.filter(
      (i) => i !== item
    );
    this.trustedemailIdInList = [];
    for (var i = 0; i < this.trustedEmailafterDeleting.length; i++) {
      var fetchedValue = this.trustedEmailafterDeleting[i];
      var commaSeperated = fetchedValue.split(",");
      var Username = commaSeperated[0];
      var Useremail = commaSeperated[1];
      var trustedemailFieldController = this;

      if (Useremail && Username != null) {
        this.trustedemailIdInList.push({
          name: Username,
          email: Useremail,
          trustedEmail: true,
        });
      }
    }
  };

  handlePaste = (evt) => {
    var scheduleReportComp = this;
    evt.preventDefault();

    var paste = evt.clipboardData.getData("text");
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

    if (paste && scheduleReportComp.isValid(paste)) {
      scheduleReportComp.state.items.push(paste);
      scheduleReportComp.setState(scheduleReportComp.state);
    }
  };

  isValid(email) {
    var fetchedValue = email;
    var commaSeperated = fetchedValue.split(",");
    let error = null;
    if (commaSeperated[0] == "") {
      error = `Please give a valid email format.`;
    }
    var Username = commaSeperated[0];
    var Useremail = commaSeperated[1];

    if (this.isInList(email)) {
      error = `${email} has already been added.`;
    }

    if (!this.isEmail(email)) {
      error = `${email} is not a valid email address.`;
    }

    if (error) {
      this.setState({ error });

      return false;
    }
    this.allEmail.push(email);

    if (Useremail && Username != null) {
      var trustedEmail = false;
      if (this.state.selectedReportType == "DAILY_SUMMARY") {
        trustedEmail = true;
      }
      this.emailIdInList.push({
        name: Username,
        email: Useremail,
        trustedEmail: trustedEmail,
      });
    }
    return true;
  }

  isInList(email) {
    return this.state.items.includes(email);
  }

  isEmail(email) {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  }

  //for trusted

  trustedMailhandleKeyDown = (evt) => {
    if (["Enter", "Tab"].includes(evt.key)) {
      evt.preventDefault();

      var value = [];
      value = this.state.trustedValue;

      if (value && this.isValidTrustedMail(value)) {
        this.setState({
          trustedItems: [...this.state.trustedItems, this.state.trustedValue],
          trustedValue: "",
        });
      }
    }
  };

  trustedMailhandlePaste = (evt) => {
    evt.preventDefault();

    var paste = evt.clipboardData.getData("text");
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

    if (paste && this.isValidTrustedMail(paste)) {
      var toBeAdded = emails.filter((email) => !this.isInList(email));

      this.state.trustedItems.push(paste);
      this.setState(this.state);
    }
  };

  isValidTrustedMail(email) {
    var fetchedValue = email;
    var commaSeperated = fetchedValue.split(",");
    let trustedError = null;
    if (commaSeperated[0] == "") {
      trustedError = `Please give a valid email format.`;
    }
    var Username = commaSeperated[0];
    var Useremail = commaSeperated[1];

    if (this.isInListTrustedMail(email)) {
      trustedError = `${email} has already been added.`;
    }

    if (!this.isEmailTrusted(email)) {
      trustedError = `${email} is not a valid email address.`;
    }

    if (trustedError) {
      this.setState({ trustedError });

      return false;
    }

    var emailFieldController = this;

    this.allEmail.push(email);

    if (Useremail && Username != null) {
      this.trustedemailIdInList.push({
        name: Username,
        email: Useremail,
        trustedEmail: true,
      });
    }

    return true;
  }

  isInListTrustedMail(email) {
    return this.state.trustedItems.includes(email);
  }

  isEmailTrusted(email) {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  }

  render() {
    const selectedDomainOption = this.state.selectedDomainName;

    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />
        <div style={{ display: this.state.successResp ? "block" : "none" }}>
          {/* for email-css */}
          <link rel="stylesheet" href="assets/css/scheduleReportStyle.css" />
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          <div className="content-header"></div>

          <div className="content">
            <div className="container-fluid">
              <div className="row" style={{ marginLeft: "10px" }}>
                <div className="col-12">
                  <div className="card-header d-flex p-0">
                    <label>Report Type</label>

                    <select
                      className="input-group mb-3 form-control select2 "
                      style={{
                        width: "200px",
                        marginLeft: "12px",
                        marginTop: "-6px",
                        cursor: "pointer",
                      }}
                      tabIndex={-1}
                      aria-hidden="true"
                      name="selectReportType"
                      id="selectReportType"
                      onChange={this.handleReportType}
                    >
                      {this.state.types.map((item) => (
                        <option value={item.code}>{item.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <form role="form" className="raiseTicketLable">
                            <div className="card-body raise-form">
                              <div className="row">
                                <div className="col-sm-1.5"></div>
                              </div>
                              <div className="row">
                                <div className="col-sm-6"></div>
                                <div className="col-sm-6" Align="right">
                                  <button
                                    type="button"
                                    className="btn btn-primary pull-right navyblue-btn"
                                    onClick={this.editContent}
                                    style={{
                                      marginTop: "24px",
                                      width: "66px",
                                      backgroundColor: "#282a65",
                                      color: "white",
                                    }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <label className="col-12 pull-left ">
                                      Time
                                    </label>
                                    <input
                                      disabled={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      type="time"
                                      className="form-control col-11"
                                      id="time"
                                      name="time"
                                      placeholder="Enter Time"
                                      value={this.state.fields.time}
                                      style={{
                                        width: "78%",
                                        cursor: "pointer",
                                        border: "1px solid #D2D4DC",
                                        borderRadius: "4px",
                                      }}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                </div>

                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <label className="col-12 pull-left ">
                                      Reporting Time Zone
                                    </label>
                                    <select
                                      className="input-group form-control select2 "
                                      disabled={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      id="timeZone"
                                      name="timeZone"
                                      style={{
                                        width: "80%",
                                        background: "white",
                                      }}
                                      placeholder="Enter Reporting Time Zone .."
                                      value={this.state.fields.timeZone}
                                      onChange={this.timeZonehandleChange}
                                    ></select>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div
                                  className="col-sm-6"
                                  style={{ marginRight: ".7rem" }}
                                >
                                  <div>
                                    <label>Email IDs</label>

                                    <input
                                      id="emailId"
                                      className={
                                        "form-control col-11" +
                                        (this.state.error && " has-error")
                                      }
                                      value={this.state.value}
                                      onKeyDown={this.handleKeyDown}
                                      style={{
                                        width: "79%",
                                        border: "1px solid #D2D4DC",
                                        borderRadius: "4px",
                                      }}
                                      onChange={this.emailIdhandleChange}
                                      onPaste={this.handlePaste}
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                    ></input>

                                    {this.state.items.map((item) => (
                                      <div
                                        className="tag-item-emailId"
                                        key={item}
                                      >
                                        {item}
                                        <button
                                          type="button"
                                          className="button"
                                          onClick={() =>
                                            this.handleDelete(item)
                                          }
                                          disabled={
                                            this.state.editedId == 0
                                              ? true
                                              : false
                                          }
                                        >
                                          &times;
                                        </button>
                                      </div>
                                    ))}
                                    {this.state.error && (
                                      <p className="error">
                                        {this.state.error}
                                      </p>
                                    )}
                                    <label
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      style={{ fontSize: "12px" }}
                                    >
                                      Please follow the Email ID in below format
                                    </label>
                                    <label
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      style={{ fontSize: "15px" }}
                                    >
                                      e.g. John, john@example.com and press
                                      Enter
                                    </label>
                                  </div>

                                  <div
                                    style={{
                                      display: this.state.showTrustedEmailId
                                        ? "none"
                                        : "block",
                                    }}
                                  >
                                    <label>Trusted Email IDs</label>

                                    <input
                                      id="trustedemailId"
                                      className={
                                        "form-control col-11" +
                                        (this.state.trustedError &&
                                          " has-error")
                                      }
                                      value={this.state.trustedValue}
                                      onKeyDown={this.trustedMailhandleKeyDown}
                                      style={{
                                        width: "79%",
                                        border: "1px solid #D2D4DC",
                                        borderRadius: "4px",
                                      }}
                                      onChange={this.trustedEmailIdhandleChange}
                                      onPaste={this.trustedMailhandlePaste}
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                    ></input>

                                    {this.state.trustedItems.map(
                                      (trusteditem) => (
                                        <div
                                          className="tag-item-emailId"
                                          key={trusteditem}
                                        >
                                          {trusteditem}
                                          <button
                                            type="button"
                                            className="button"
                                            onClick={() =>
                                              this.trustedhandleDelete(
                                                trusteditem
                                              )
                                            }
                                            disabled={
                                              this.state.editedId == 0
                                                ? true
                                                : false
                                            }
                                          >
                                            &times;
                                          </button>
                                        </div>
                                      )
                                    )}
                                    {this.state.trustedError && (
                                      <p className="error">
                                        {this.state.trustedError}
                                      </p>
                                    )}
                                    <label
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      style={{ fontSize: "12px" }}
                                    >
                                      Please follow the Email ID in below format
                                    </label>
                                    <label
                                      hidden={
                                        this.state.editedId == 0 ? true : false
                                      }
                                      style={{ fontSize: "15px" }}
                                    >
                                      e.g. John, john@example.com and press
                                      Enter
                                    </label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    width: "39%",
                                    display:
                                      this.state.selectedReportType ===
                                        "DOMAIN_WISE_REPORT"
                                        ? "block"
                                        : "none",
                                  }}
                                  hidden={
                                    this.state.editedId == 0 ? true : false
                                  }
                                >
                                  <label className="col-12 pull-left"
                                    style={{ visibility: this.state.selectedReportType === "DOMAIN_WISE_REPORT" ? "visible" : "hidden" }}>
                                    Domain
                                  </label>
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        visibility:
                                          this.state.selectedReportType ===
                                            "DOMAIN_WISE_REPORT"
                                            ? "visible"
                                            : "hidden",
                                      }),
                                    }}
                                    value={this.domains.filter(
                                      (option) =>
                                        option.label === selectedDomainOption
                                    )}
                                    onChange={this.handleDomainChange}
                                    options={this.domains}
                                  />
                                </div>

                                <div
                                  style={{
                                    width: "40%",
                                    padding: "10px",
                                    borderRadius: "6px",
                                    display:
                                      this.state.selectedReportType ===
                                        "DAILY_SUMMARY"
                                        ? "block"
                                        : "none",
                                  }}
                                  hidden={
                                    this.state.editedId == 0 ? true : false
                                  }
                                >
                                  <label className="col-12 pull-left">
                                    Domains
                                  </label>
                                  <Multiselect
                                    options={this.domains}
                                    displayValue="label"
                                    closeIcon="cancel"
                                    placeholder="Select Domains"
                                    selectedValues={
                                      this.state.selectedDailyReportDomains
                                    }

                                    className="multiSelectContainer"
                                    onSelect={
                                      this.handleDailyReportDomainChange
                                    }
                                    onRemove={
                                      this.handleRemoveDailyReportDomain
                                    }
                                    // onSearch={(e) => this.checkTreatmentName(e)}
                                    ref={this.multiselectRef}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-6" Align="right">
                              {/* <div className="row" > */}
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary pull-right navyblue-btn"
                                  hidden={
                                    this.state.editedId == 0 ? true : false
                                  }
                                  onClick={this.showPopup}
                                  style={{
                                    marginTop: "24px",
                                    width: "70px",
                                    marginRight: "-80px",
                                  }}
                                >
                                  Delete
                                </button>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary pull-right navyblue-btn"
                                  hidden={
                                    this.state.editedId == 0 ? true : false
                                  }
                                  onClick={this.saveScheduleReportApi}
                                  style={{
                                    marginTop: "24px",
                                    width: "66px",
                                  }}
                                >
                                  Save
                                </button>
                                {/* </div> */}
                              </div>
                            </div>
                            <ToastContainer className="Toast-at-center" />

                            {/* Dialog Component For Deletion Confirmation */}
                            <DialogComponent
                              width="400px"
                              animationSettings={this.settings}
                              header="Schedule Report"
                              showCloseIcon={true}
                              buttons={this.buttons}
                              ref={(dialog) => (this.dialogInstance = dialog)}
                              visible={this.state.hideDeletePopup}
                              close={this.dialogClose}
                            >
                              <img
                                src="./assets/images/warn.svg"
                                style={{
                                  paddingRight: "0px",
                                  height: "20px",
                                  width: "20px",
                                }}
                                content=""
                              />
                              &nbsp;Do you want to delete the Scehdule Report?
                              <br />
                              Note: Press 'Yes' to delete or press 'No' to
                              decline.
                            </DialogComponent>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ScheduleReport;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/ScheduleReport.js